import { useApiQuery } from "../../../services/api";
import { getRoomOrganization } from "../utils/getRoomOrganization";

export function useRoomOrganization(roomId: string | null) {
  const roomQuery = useApiQuery(
    "/webapp/private/rooms/:id",
    roomId !== null ? { param: { id: roomId } } : false
  );
  const currentRoom = roomQuery.state === "success" ? roomQuery.body : null;
  return getRoomOrganization(currentRoom);
}
